// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2pgvy","calendarButtons":"ClockData_calendarButtons__2rk7P"};